<div class="loggedin-quick-links" [ngClass]="{'toggle-quick-link': isAcmic}">
  <div class="quick-links-title">
    Quick links
  </div>
  <hr class="thin-hr-mb-24 mt-4"/>
  <div class="quick-link">
    <ng-container *ngIf="policies && policies.length > 1; else onePolicy">
      <a>
        <div class="title-arrow-row show-more-button" (click)="claimModal.openModal()">
          <app-claim-modal #claimModal [policies]="policies" class="display-inline" (click)="$event.stopPropagation()"></app-claim-modal> <img alt="right arrow icon"
            [src]="imgPath">
        </div>
      </a>
    </ng-container>
    <ng-template #onePolicy>
      <a [routerLink]="['/my-insurance', 'reportClaim']" (click)="reportClaim(policies[0])">
        <div class="title-arrow-row" [ngClass]="{'col-363636-imp': isAcmic}">
          {{'REPORT_A_CLAIM_TEXT' | translate }}<img alt="right arrow icon" [src]="imgPath">
        </div>
      </a>
    </ng-template>
  </div>
  <div class="quick-link">
    <a [routerLink]="['/billing', 'autopay']">
      <div class="title-arrow-row">
        {{'MANAGE_AUTOPAY' | translate }}<img alt="right arrow icon" [src]="imgPath">
      </div>
    </a>
  </div>
  <div class="quick-link">
    <a>
      <div class="title-arrow-row show-more-button" (click)="uploadTypeModal.openModal()">
        <app-upload-type-modal #uploadTypeModal [actionType]="'upload-type-link'" class="display-inline" (click)="$event.stopPropagation()"></app-upload-type-modal>
        <img alt="right arrow icon" [src]="imgPath">
      </div>
    </a>
  </div>
</div>